import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { z } from 'zod';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const SchedulesPage = lazy(() => import('~/features/catalog-enrichment/pages/schedules-page'));

/**
 * Schedules list state kept in the URL so Back / a shared link restore it: the view, search,
 * store and page. Every key is optional and a bad value falls back to "unset". An old
 * `?schedule=<id>` link opens that schedule's own page.
 */
const schedulesSearchSchema = z.object({
  view: z.enum(['FAILING', 'ACTIVE', 'PAUSED', 'ALL']).optional().catch(undefined),
  search: z.string().optional().catch(undefined),
  connector: z.string().optional().catch(undefined),
  page: z.number().int().min(1).optional().catch(undefined),
  schedule: z.string().optional().catch(undefined),
});

export const Route = createFileRoute('/_authenticated/_tenant/catalog-enrichment/schedules/')({
  validateSearch: schedulesSearchSchema,
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <SchedulesPage />
    </Suspense>
  ),
});
